<template>
  <svg
    width="13px"
    height="14px"
    viewBox="0 0 13 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>delete</title>
    <desc>Created with Sketch.</desc>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="INQUIRE"
        transform="translate(-1524.000000, -408.000000)"
        fill="currentColor"
        fill-rule="nonzero"
      >
        <path
          d="M1530.40762,408.000002 L1530.58064,408.004889 C1532.01158,408.089465 1533.15881,409.259818 1533.20281,410.718809 L1533.20281,410.718809 L1536.04071,410.718809 C1536.43539,410.718809 1537,410.81214 1537,411.206011 C1537,411.601742 1536.70749,411.742681 1536.31467,411.742681 L1536.31467,411.742681 L1535.96086,411.742681 L1535.97943,420.057727 C1535.97943,421.240258 1535.59775,422.000002 1534.10544,422.000002 L1534.10544,422.000002 L1526.78777,422.000002 C1525.5304,422.000002 1524.93606,421.350391 1524.93606,420.057741 L1524.93606,420.057741 L1524.93606,411.743598 L1524.68163,411.743598 C1524.28602,411.743598 1524,411.599869 1524,411.206941 C1524,410.81121 1524.28881,410.716006 1524.68163,410.716006 L1524.68163,410.716006 L1527.60778,410.716006 C1527.65938,409.199851 1528.89822,407.998115 1530.40762,408.000002 L1530.40762,408.000002 Z M1535.05544,411.733357 L1525.78765,411.733357 L1525.78765,420.130548 C1525.78765,420.950013 1526.19718,421.045216 1526.78964,421.045216 L1526.78964,421.045216 L1534.20668,421.045216 C1534.65149,421.045216 1535.05544,420.948139 1535.05544,420.129619 L1535.05544,420.129619 L1535.05544,411.733357 Z M1528.30517,413.603729 C1528.56147,413.603729 1528.76948,413.779192 1528.76948,414.183319 L1528.76948,414.183319 L1528.76948,418.330136 C1528.76948,418.735192 1528.55961,418.931191 1528.30517,418.931191 C1528.04514,418.931191 1527.84085,418.731459 1527.84085,418.330136 L1527.84085,418.330136 L1527.84085,414.183319 C1527.84085,413.779192 1528.05072,413.603729 1528.30517,413.603729 Z M1530.44475,413.600927 C1530.70105,413.600927 1530.90906,413.780136 1530.90906,414.184262 L1530.90906,414.184262 L1530.90906,418.329192 C1530.90906,418.734248 1530.69919,418.879863 1530.44474,418.879863 L1530.44474,418.879863 C1530.1903,418.880793 1529.98042,418.732389 1529.98042,418.331065 L1529.98042,418.331065 L1529.98042,414.184262 C1529.98042,413.780136 1530.1903,413.600927 1530.44475,413.600927 Z M1532.69484,413.603729 C1532.95114,413.603729 1533.15915,413.780136 1533.15915,414.184262 L1533.15915,414.184262 L1533.15915,418.329192 C1533.15915,418.734262 1532.94928,418.870525 1532.69484,418.870525 L1532.69484,418.870525 C1532.43297,418.871455 1532.23051,418.732389 1532.23051,418.331065 L1532.23051,418.331065 L1532.23051,414.184276 C1532.23051,413.780136 1532.44039,413.603729 1532.69484,413.603729 Z M1530.44476,408.911883 C1529.48826,408.911883 1528.65249,409.745335 1528.58749,410.792546 L1528.58749,410.792546 L1532.30018,410.792546 C1532.24539,409.747208 1531.39941,408.911883 1530.44476,408.911883 Z"
          id="delete"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Delete'
});
</script>
